import { useMutation, useQuery } from "@apollo/client";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useSelector } from "react-redux";
import IsoToDateTime, { IsoToDateWithoutTime, convertToISO } from "../../../../CommonFunction/IsoDateTime";
import { Loading, OutsideClick } from "../../../Components";
import Input from "../../../Components/Input/Input";
import SidebarPortal from "../../../Components/SidebarPortal/SidebarPortal";
import { ErrorToast } from "../../../Components/ToastComponent/RectHotToast";
import useModal from "../../../custom_hooks/useModal";
import { checkChangedValue, checkPriority } from "../utils/TaskDetails";
import { Task_Inputs } from "../utils/constants";
import { DeleteTaskCard, Edit_Task_details, GET_ALL_TASKS, GetTaskDetailsByID } from "../utils/quires";
import Attachments from "./Attachments";
import "./EditTask.scss"; // Import SCSS for styling
import EditableTextArea from "./EditableTextArea";
import EditableDiv from "./Editablediv";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { useEventListener, useOnClickOutside } from 'usehooks-ts';
import { useModalContext } from "../../../Components/Reactportal/ModalContext";
import { MdOutlineDeleteOutline } from "react-icons/md";
import DeleteBoard from "../DeleteBoard";
import { getPageDetails } from "../../../custom_hooks/CheckPageAccess";
import { useDispatch } from "react-redux";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";

interface EditTaskProps {
  open: boolean;
  TaskId: string;
  handleEditTask: Function;
  DeleteTask: any;
}
interface TaskDetails {
  Assignee: string | null;
  Reporter: string | null;
  Priority: string | null;
  Start_Date: any;
  Due_Date: any;
}
interface DateDetails {
  createdAt: string;
  updatedAt: string | null;
  Task_Code: string | undefined;
  Description: string | null;
  Attached_Files: string[];
  Title: string | null;
}
let initalstate = {
  Assignee: null,
  Reporter: null,
  Priority: null,
  Start_Date: null,
  Due_Date: null,
}
const StatusChange = ({ Changed_By, Changed_At, Field_Name, New_Data, Previous_Data, index }) => {
  return (
    <div className="status-change">
      <div>
        <span className="name">{Changed_By}</span>
        <span className="action">
          {" "}
          {index === 0 ? "created " : "changed "}the {Field_Name}{" "}
        </span>
        <span className="date">{Changed_At}</span>
      </div>
      <div className={(New_Data || Previous_Data) ? "status-update" : "hide-status"} >
        {(New_Data || Previous_Data) && checkChangedValue(Field_Name, Previous_Data, New_Data)}
      </div>
    </div>
  );
};

const EditTask: React.FC<EditTaskProps> = ({ open, TaskId, handleEditTask, DeleteTask }) => {

  const [toggle, settoggle] = useState(false);
  const { isOpenModal, onOpenModal, onCloseModal } = useModal();
  const FormKey = "EditStatusTask";
  const dispatch = useDispatch();
  const { modalStack, getTopModal, popModal, pushModal } = useModalContext()
  const [details, setDetails] = useState<TaskDetails>(initalstate);
  const [openDetail, setOpenDetail] = useState(true);
  const [editingField, setEditingField] = useState<string | null>(null);
  const [Field, setField] = useState<string | null>(null);
  const [Histroy, SetHistroy] = useState([]);
  const [apicallsignal, setapicalSignal] = useState(false);
  const [OpenAttachMent, setOpenAttachMent] = useState(false)
  const [alldetails, setalldetails] = useState<DateDetails | null>(null);
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const [triggerApiCall, setTriggerApiCall] = useState(false);
  let AssigneID = FormDataFromRedux?.MasterData?.[FormKey]?.Assignee;
  let ReporterID = FormDataFromRedux?.MasterData?.[FormKey]?.Reporter;
  const {
    loading: TaskLoading,
    data: TaskData,
    refetch,
  } = useQuery(GetTaskDetailsByID, {
    variables: { taskId: TaskId },
    fetchPolicy: "network-only",
  });

  const [TaskEditQuery] = useMutation(Edit_Task_details, {
    onCompleted: () => {
      // SuccessToast(`Task ${Field} edited sucessfully `);
    },
    onError: (err) => {
      ErrorToast(`${err.message}`);
    },
  });
  const Pagedetails: any = useMemo(() => {
    return getPageDetails("StatusBoard",);
  }, []);
  const HandleDeleteTask = () => {
    DeleteTask({
      variables: {
        deleteTaskCardId: TaskId,
        pageId: Pagedetails.Page_Id
      },
    }).finally(() => {
      settoggle(false)
      CloseModel();
    })
  }

  const ref = useRef(null);

  useEffect(() => {
    setEditingField(null);
    setDetails(initalstate);
    setField(null);
  }, [TaskId]);

  useEffect(() => {
    if (TaskData?.GetTaskDetailsByID) {
      const data = TaskData?.GetTaskDetailsByID;
      const detaisdata: TaskDetails = {
        Assignee: data?.Assignee?.Full_Name,
        Reporter: data?.Reporter?.Full_Name,
        Priority: data.Priority,
        Start_Date: data.Start_Date ? IsoToDateWithoutTime(data.Start_Date) : null,
        Due_Date: data.Due_Date ? IsoToDateWithoutTime(data.Due_Date) : null,
      };
      // setDetails(detaisdata)
      setalldetails(data);
      setDetails(detaisdata);

      const History_details = TaskData?.GetTaskDetailsByID?.History.map((ele) => {
        return {
          ...ele,
          Changed_At: IsoToDateTime(ele.Changed_At),
        };
      });
      SetHistroy(History_details);
    }
  }, [TaskData]);
  useEffect(() => {
    if (open) {

      onOpenModal();
    }
  }, [open, onOpenModal]);
  useEffect(() => {
    pushModal(FormKey)
  }, [])
  useEffect(() => {
    if (Field === "Assignee" && AssigneID?._id) {
      const userInput = {
        Assignee: AssigneID._id,
      };
      TaskEditQuery({
        variables: {
          id: TaskId,
          userInput,
        },
      });
    } else if (Field === "Reporter" && ReporterID?._id) {
      const userInput = {
        Reporter: ReporterID._id,
      };
      TaskEditQuery({
        variables: {
          id: TaskId,
          userInput,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AssigneID, ReporterID, Field, TaskId]);
  // Using useEffect to trigger API calls when necessary fields update

  useEffect(() => {
    const makeApiCall = () => {
      let userInput = {};
      if (Field === "Priority" && details?.Priority) {
        userInput = { Priority: details.Priority };
      } else if (Field === "Start_Date" && details?.Start_Date) {
        userInput = { Start_Date: convertToISO(details.Start_Date) };
      } else if (Field === "Due_Date" && details?.Due_Date) {
        userInput = { Due_Date: convertToISO(details.Due_Date) };
      }


      if (Object.keys(userInput).length > 0) {
        setTimeout(() => {
          TaskEditQuery({
            variables: {
              id: TaskId,
              userInput,
            },
          });
          setTriggerApiCall(false); // Reset trigger after initiating the API call
        }, 100); // Delay the API call by 100 milliseconds
      }
    };
    if (triggerApiCall) {
      makeApiCall();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerApiCall, details, Field]); // Assuming Field is a dependency

  const handleInputChange = (field: string, value: any) => {
    setapicalSignal(true);
    setDetails((prev) => {
      return {
        ...prev, [field]: value.target.value
      }
    })
  };

  const toggleDetails = () => setOpenDetail((prev) => !prev);
  function CloseModel() {
    if (apicallsignal) {
      refetch();
    }
    onCloseModal();
    handleEditTask(null); // Reset the editing task
    popModal(FormKey);
    setDetails(initalstate);
    ClearSpecificForm(dispatch,FormKey)
  };
  const handleEditClick = (field: string) => {
    setEditingField(field);
  };
  const handleBlur = async (field: string) => {

    setapicalSignal(true);
    setField(field);
    setTriggerApiCall(true); // Indicate that an API call should be triggered
  };
  const handleAttechmentsOpen = (AtachMentopen: any) => {
    setOpenAttachMent(AtachMentopen)
  }
  return (
    <>
      <SidebarPortal
        open={isOpenModal}
        position="right"
        onClose={CloseModel}
        heading={alldetails?.Task_Code + "  Card Details "}
        renderHeaderRightSideContenet={<MdOutlineDeleteOutline className="closeIcon" style={{ color: "red" }} onClick={() => {
          settoggle(true)
        }} />}
      >
        {TaskLoading ? (
          <Loading />
        ) : (
          <OutsideClick
            setToggled={() => {
              setEditingField(null);
            }}
          >
            <div className="edit-task" ref={ref}>
              <EditableDiv
                Title={alldetails?.Title}
                handleEdit={TaskEditQuery}
                id={TaskId}
                setapicalSignal={setapicalSignal}
              />
              <EditableTextArea Description={alldetails?.Description} handleEdit={TaskEditQuery} id={TaskId} />
              <Attachments attachments={alldetails?.Attached_Files} TaskId={TaskId} handleOpen={handleAttechmentsOpen} />
              <div className="details-container">
                <div className="header-container" onClick={toggleDetails}>
                  <span>Details</span>
                  <span>{openDetail ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                </div>
                {openDetail &&
                  details &&
                  Object.entries(details)?.map(([key, value]) => {
                    const inputdata = Task_Inputs[0].fields.find((ele) => key === ele.name);
                    console.log({ key, value }, "valuevaluevaluevaluevaluevalue")
                    return (
                      <>
                        {/* <OutsideClick setToggled={()=> setEditingField(null)}> */}
                        <div key={key} className="details-content">
                          <div className="details-children">
                            <p>{replaceUnderscore(key)}</p>
                          </div>
                          <div className="details-children-two" onClick={() => handleEditClick(key)}>
                            {editingField === key ? (
                              <Input
                                value={value}
                                handleInputChange={(e) => handleInputChange(key, e)}
                                handleBlur={() => handleBlur(key)}
                                EMTQuery=""
                                checked={""}
                                InputConfig={inputdata}
                                JurnalDropdown=""
                                Section_Type=""
                                disabled=""
                                onFocus={() => { }}
                                transactions=""
                                PaymentProcess=""
                                TypeOfPortal={"Edit"}
                                name={key}
                                label={""}
                                className={"input-class"}
                                type={inputdata?.type}
                                modalform={true}
                                dropdowndata={inputdata?.dropdowncontent ? inputdata?.dropdowncontent : []}
                                touched={() => { }}
                                error={""}
                                max={undefined}

                                notSearchable={
                                  true
                                  // inputdata?.name === "Priority" ? true : false
                                }
                                formkey={FormKey}
                              />
                            ) : key === "Priority" ? (
                              <div className="image-priorioty">
                                {checkPriority(value)} <p>{value ? value : "None"}</p>
                              </div>
                            ) : (
                              <p>{value ? value : "None"}</p>
                            )}
                          </div>
                        </div>
                        {/* </OutsideClick> */}
                      </>
                    );
                  })}
              </div>

              <div className="created-container">
                <span className="created-details">
                  <span>Created</span>
                  <span>{IsoToDateTime(alldetails?.createdAt)}</span>
                </span>
                <span className="created-details">
                  <span>Updated</span>
                  <span>{IsoToDateTime(alldetails?.updatedAt)}</span>
                </span>
              </div>
              {/* the Task  details  */}
              <div className="histy-container">
                <div className="history-title">
                  <p>
                    <span>{alldetails?.Task_Code}</span> Card History
                  </p>
                </div>
                {Histroy?.map((element: any, index) => (
                  <StatusChange
                    key={index}
                    Changed_By={element?.Changed_By}
                    Changed_At={element?.Changed_At}
                    Field_Name={element?.Field_Name}
                    New_Data={element?.New_Data}
                    Previous_Data={element?.Previous_Data}
                    index={index}
                  />
                ))}
              </div>
            </div>
          </OutsideClick>
        )}
      </SidebarPortal>
      <DeleteBoard toggle={toggle} settoggle={settoggle} DeleteLoad={false} handleClick={HandleDeleteTask} text="Task from Board" />
    </>
  );
};

export default EditTask;

// alldetails?.Task_Code
//